<template>
  <div>
    <div class="hero-img" id="hero">
      <picture>
        <!-- <source :srcset="img_pc1024_src" media="(min-width: 1025px)"> -->
        <source :srcset="img_pc_src" media="(min-width: 769px)">
        <source :srcset="img_574_src">
        <img
          :src="img_pc_src"
          id="hero-image"
          width="100%"
          alt="Ипотечен кредит при спешни плащания"
        >
      </picture>

      <!-- odl way -->
      <!-- <img :src="img_574_src" class="hero-574px" width="100%" alt="">
      <img :src="img_pc_src" class="hero-pc" width="100%" alt="">-->
    </div>

    <div class="hero-text has-text-left">
      <!-- *** Girl & City EXTRA BOLD *** -->
      <h1 class="title big">КРЕДИТ</h1>
      <br class="is-hidden-mobile">
      <br>
      <h1 class="title">
        ДО
        <strong>150'000 € (293'374.50 лв)</strong>
      </h1>
      <br class="is-hidden-mobile">
      <br>
      <h1 class="title">
        <br class="is-hidden-tablet">
        <strong>ИПОТЕЧЕН</strong>
      </h1>
      <!-- /END - *** Girl & City EXTRA BOLD *** -->
      <!-- <br><br> -->
      <!-- <p class="paragraph">
        <strong>ИПОТЕЧЕН</strong> кредит за спешни нужди.
        <br> <strong>Независимо</strong> от кредитната ви история.
      </p>-->
      <p class="hero-button">
        <button @click="navTo('application-form')" class="button is-rounded">ВЗЕМИ ИПОТЕЧЕН КРЕДИТ</button>
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HeroFamilyAndKite',
  data () {
    return {
      showHeroText: false,
      fullHeight: true,

      img_574_src: require('../assets/img/family-and-kite@mobile-preload.jpg'),
      img_pc_src: require('../assets/img/family-and-kite@800x304-preload.jpg')

    }
  },
  methods: {
    navTo (anchor) {
      this.$eventBus.loadLazy(() => {
        this.$scrollTo('#' + anchor, 500, {offset: -77})
      })
    }
  },
  beforeCreate () {
    // CITY AND GIRL
    this.$helpers.lazyImageLoad(0, this.$_config.BASE_URL + 'static/img/family-and-kite@mobile.jpg',
      imgSrc => { this.img_574_src = imgSrc }
    )
    this.$helpers.lazyImageLoad(0, this.$_config.BASE_URL + 'static/img/family-and-kite@800x304.jpg',
      imgSrc => { this.img_pc_src = imgSrc }
    )

    // // this.$helpers.lazyImageLoad(0, this.$_config.BASE_URL + 'static/img/city-girl@desktop1024.jpg',
    // //   imgSrc => { this.img_pc1024_src = imgSrc }
    // // )
  }
}
</script>

<style lang="stylus" scoped>
// visibility hidden
$color = black + 17%;
// $color = #94cccc - 27%
// $color = #1680CB + 33
$colorPlus = #1680CB + 24;

img {
  display: block;
}

div.hero-text {
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4);
}

// под 768px
@media (max-width: 768px) {
  // img.hero-pc
  // display none
  div.hero-text {
    position: absolute;
    top: 10%;
    left: 5vw; // Girl Extra Bold: 12vw; Bridge: 9vw
    // width 100%
    margin: auto;
    // color #4f4f4f
    text-shadow: 0px 1px 1px rgba(255, 255, 255, 0.4);

    & h1.title.big {
      display: inline;
      font-weight: 700;
      font-size: 12vw; // 14 // 50px // 40px
    }

    & h1.title {
      display: inline;
      font-weight: 300;
      font-size: 6vw; // 8 // 50px // 40px

      strong {
        font-weight: 700;
      }
    }

    & h2.subtitle {
      strong {
        font-weight: 700;
      }

      font-size: 2.4vw - 10%;

      .bigger {
        font-size: 2.4vw;
      }

      .gold {
        color: #cc3300;
        font-weight: 400;
      }
    }

    & p.paragraph {
      display: none;
      // width 450px
      margin: 35px auto 0 auto;
      color: #330000;
      font-weight: 400;
    }

    & .hero-button {
      margin: 2vw auto 0 auto;

      & .button {
        border: solid 1px ($colorPlus + 10%);
        background: $colorPlus + 10%;
        color: white;
        // margin auto
        text-transform: uppercase;
        // opacity 0.8
        font-size: 4.8vw;
      }
    }
  }
}

// end of под 768px

// от 768px +
@media (min-width: 769px) {
  // img.hero-574px
  // display none
  div.hero-text {
    position: absolute;
    top: 7%;
    left: 9vw; // Girl Extra Bold: 12vw; Bridge: 9vw
    margin: auto;
    // left 8vw
    width: 100%;
    // color #4f4f4f
    text-shadow: 0px 1px 1px rgba(255, 255, 255, 0.4);

    & h1.title.big {
      display: inline;
      font-weight: 700;
      font-size: 8vw; // 50px // 40px
    }

    & h1.title {
      display: inline;
      font-weight: 300;
      font-size: 3.8vw; // 50px // 40px

      strong {
        font-weight: 700;
      }
    }

    & h2.subtitle {
      strong {
        font-weight: 700;
      }

      font-size: 2.4vw - 10%;

      .bigger {
        font-size: 2.4vw;
      }

      .gold {
        color: #cc3300;
        font-weight: 400;
      }
    }

    & p.paragraph {
      width: 50vw; // 450px
      color: black;
      text-transform: uppercase;
      font-weight: 400;
      font-size: 1.7vw; // 1.4vw // 1.7vw // 24px // 19px
      // margin 35px auto 0 auto
    }

    & .hero-button {
      margin: 4.5vw auto 0 auto;

      & .button {
        border: solid 1px ($colorPlus + 10%);
        background: $colorPlus + 10%;
        color: white;
        // margin auto
        text-transform: uppercase;
        // opacity 0.8
        font-size: 1.4vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeroFamilyAndKite.vue